// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const medicalClearanceAccessService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/AccessTemplate/medical-clearance-access`, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/AccessTemplate/medical-clearance-access/${id}`, payload, { headers });
  }
};